module.exports = __webpack_public_path__ + "img/OCS_Software_Logo_2017_WO.93c4474a.png";